import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DoubleChevronLeftIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("polyline", {
    points: "12.19 17.99 6.15 11.99 12.14 6.01",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "17.85 17.99 11.81 11.99 17.8 6.01",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })]
}), 'DoubleChevronLeftIcon');